/**
 * @generated SignedSource<<461ebd5547de6f87cc931e996c0fe619>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProfileAvailabilityEnum = "available_now" | "available_soon" | "not_available";
export type ProfileAvailabilityTypeLiteral = "full_time" | "part_time";
import { FragmentRefs } from "relay-runtime";
export type AvailabilityEditDialog_User$data = {
  readonly profile: {
    readonly availability: ProfileAvailabilityEnum | null | undefined;
    readonly availabilityType: ReadonlyArray<ProfileAvailabilityTypeLiteral> | null | undefined;
    readonly availableAt: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AvailabilityEditDialog_User";
};
export type AvailabilityEditDialog_User$key = {
  readonly " $data"?: AvailabilityEditDialog_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"AvailabilityEditDialog_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvailabilityEditDialog_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availability",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availableAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availabilityType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "03ceef663ed55d03313a03f932a427e2";

export default node;
